import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/persistent";
/**
 * reducer for changes to ephemeral session state
 */
export const persistentReducer = {
    reducers: {
        [actions.setGameInfo]: (state, payload) => {
            const { gameId, provider, priority, expires, values } = payload;
            let temp = state;
            values.forEach((val) => {
                temp = setSafe(temp, ["gameInfo", gameId, val.key], {
                    provider,
                    expires,
                    priority,
                    title: val.title,
                    value: val.value,
                    type: val.type,
                });
            });
            return temp;
        },
    },
    defaults: {
        gameInfo: {},
    },
};
